module.exports = __webpack_public_path__ + "9d6320ace80d16741a2ff34a59ac24ef.svg";